var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',{staticClass:"nano"},[_vm._v(" Copyright 2020 - ")]),_c('p',{staticClass:"nano"},[_vm._v(" Made With "),_c('font-awesome-icon',{staticStyle:{"color":"#a5043a"},attrs:{"icon":"heart"}}),_vm._v(" By Shabnam ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }